import { renderTeachingPopoverCarouselNavButton_unstable } from '@fluentui/react-teaching-popover';
import type { JSXElement } from '@fluentui/react-utilities';
import type { TeachingPopoverCarouselNavButtonState } from './TeachingPopoverCarouselNavButton.types';

export const renderTeachingPopoverCarouselNavButton = renderTeachingPopoverCarouselNavButton_unstable as (
  state: TeachingPopoverCarouselNavButtonState,
) => JSXElement;
